import { useEffect } from 'react';
import { Pages } from '@constants/pages';
import ChatPage from '@pages/chat-page/chat-page';
import { NotFound } from '@pages/not-found';
import PDFViewer from '@pages/pdf-viewer/pdf-viewer';
import ChatProvider from '@stores/providers/chat-provider';
import ThemeProvider from '@stores/providers/theme-provider';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import './styles/index.css';

function App() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('common.document_title');
  }, [t]);
  return (
    <ThemeProvider>
      <ChatProvider>
        <Routes>
          <Route path="/instance/:instance" element={<ChatPage />} />
          <Route path={`/instance/:instance${Pages.PDFViewer}/:docId`} element={<PDFViewer />} />
          <Route path={`${Pages.PDFViewer}/:docId`} element={<PDFViewer />} />
          <Route path={Pages.Chat} element={<ChatPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ChatProvider>
    </ThemeProvider>
  );
}

export default App;
